import { render, staticRenderFns } from "./getStop.vue?vue&type=template&id=daf1dee2&scoped=true&"
import script from "./getStop.vue?vue&type=script&lang=js&"
export * from "./getStop.vue?vue&type=script&lang=js&"
import style0 from "./getStop.vue?vue&type=style&index=0&id=daf1dee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf1dee2",
  null
  
)

export default component.exports